// import React from 'react';
// import filter from '../../filter';
// import ListStats from '../ListStats';
// import ListMap from '../ListMap';
// import ListResults from '../ListResults';
// import shallowequal from 'shallowequal';
// import request from 'arcdynamic-request';
// import {V7_PROPERTIES_MAP, V7_PROPERTIES_STATS} from '../../consts/queries';

// const limit = 1000;

// export default class ListingMap extends React.Component {
// 	constructor(props) {
// 		super(props);
// 		this.state = {
// 			items: null,
// 			totalCount: null,
// 			stats: null,
// 			error: null,
// 			isBusy: null,
// 			query: this.props.location.query,
// 		};
// 	}

// 	componentDidMount() {
// 		this.fetch(this.props.location.query);
// 	}

// 	fetch(q) {
// 		this.setState({isBusy: true});

// 		const query = {...q};
// 		const options = filter(query);
// 		options.param.limit = limit;
// 		options.param.offset = query.page ? ((Number(query.page) - 1)*limit) : 0;

// 		Promise.all([
// 			request(arc.path.api, {
// 				service: 'arcimedes',
// 				action: 'open.dataquery.execute',
// 				params: [V7_PROPERTIES_MAP],
// 				options,
// 			}, {
// 				expires: 1000*10
// 			}),
// 			request(arc.path.api, {
// 				service: 'arcimedes',
// 				action: 'open.dataquery.execute',
// 				params: [V7_PROPERTIES_STATS],
// 				options,
// 			}, {
// 				expires: 1000*10
// 			}),
// 		]).then(values => {
// 			this.setState({
// 				items: values[0].success ? values[0].data : null,
// 				totalCount: values[1].data && values[1].data.length && typeof values[1].data[0].count === 'string' ? Number(values[1].data[0].count) : limit,
// 				stats: values[1].data[0],
// 				error: values[0].success ? null : values[0].message,
// 				isBusy: null,
// 				query,
// 			});
// 		});
// 	}

// 	componentDidUpdate(prevProps) {
// 		if (!shallowequal(prevProps.location.query, this.props.location.query)) {
// 			this.fetch(this.props.location.query);
// 		}
// 	}

// 	render() {
// 		return (
// 			<div className='ListingMap' data-is-busy={this.state.isBusy}>
// 				<ListStats stats={this.state.stats} query={this.state.query}/>
// 				<ListMap listings={this.state.items}/>
// 				<ListResults query={this.props.location.query} pathname={this.props.location.pathname} error={this.state.error} totalCount={this.state.totalCount} itemCount={this.state.items ? this.state.items.length : false} limit={limit}/>
// 			</div>
// 		);
// 	}
// }

import React from "react"; //new code
import filter from "../../filter";
import ListStats from "../ListStats";
import ListMap from "../ListMap";
import ListResults from "../ListResults";
import shallowequal from "shallowequal";
import request from "arcdynamic-request";
import { V7_PROPERTIES_MAP, V7_PROPERTIES_STATS } from "../../consts/queries";
import {
  V7_PROPERTIES_MAP_QUERY,
  V7_PROPERTIES_STATS_QUERY,
} from "../Graphql/Queries/propertiesQuery";
import { ApolloConsumer } from "@apollo/client";
import { fetchData } from "../Service/graphQlService";

const limit = 1000;

export default class ListingMap extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: null,
      totalCount: null,
      stats: null,
      error: null,
      isBusy: null,
      query: this.props.location.query,
	  clientData:{}
    };
	this.client = null;
  }

  componentDidMount() {
    this.fetch(this.props.location.query)

	}

  fetch(q) {
    this.setState({ isBusy: true });

    const query = { ...q };
    const options = filter(query);
    options.param.limit = limit;
    options.param.offset = query.page ? (Number(query.page) - 1) * limit : 0;
	function transformParams(params) {
		if (params) {
		  // Initialize status array
		  params.status = [];
		  
		  // Loop through status_1 to status_8
		  for (let i = 1; i <= 8; i++) {
			let statusKey = `status_${i}`; // Use backticks for string interpolation
	  
			// Check if the status value is not "NOMATCH" and has a value
			if (params[statusKey] && params[statusKey] !== "NOMATCH") {
			  params.status.push(params[statusKey]); // Add to the status array
			}
	  
			// Remove status_x keys
			delete params[statusKey];
		  }
	  
		  // Prepare the final result
		  const result = {
			listOptions: {
			  source: params.source,
			  transaction_type: params.transaction_type,
			  status: params.status
			},
			pageOptions: {
			  page: params.offset || 1, // Default to 1 if offset is not present
			  pageSize: params.limit || 1000 // Default to 1000 if limit is not present
			}
		  };
	  
		  // Return the result object
		  return result;
		}
	  }

    const updatedParams = transformParams(options.param);
	const token = localStorage.getItem('authToken');
    Promise.all([
    //   request(
        // this.client.query({
        //   query: V7_PROPERTIES_MAP_QUERY,
        //   variables: { listOptions: updatedParams.listOptions, pageOptions : updatedParams.pageOptions },
        //   fetchPolicy: "no-cache",
        //   context: {
        //     headers: {
        //       authorization: `Bearer ${token}`,
        //     },
        //   },
        // }),
        fetchData(V7_PROPERTIES_MAP_QUERY,{ listOptions: updatedParams.listOptions, pageOptions : updatedParams.pageOptions }),
    //   ),
    //   request(
        // this.client.query({
        //   query: V7_PROPERTIES_STATS_QUERY,
        //   variables: { listOptions: updatedParams.listOptions,pageOptions:updatedParams.pageOptions },
        //   fetchPolicy: "no-cache",
        //   context: {
        //     headers: {
        //       authorization: `Bearer ${token}`,
        //     },
        //   },
        // })
        fetchData(V7_PROPERTIES_STATS_QUERY,{ listOptions: updatedParams.listOptions,pageOptions:updatedParams.pageOptions }),
    //   ),
    ]).then((values) => {
      this.setState({
        items: values[0].data.v7PropertiesMap.length > 0  ?  values[0].data.v7PropertiesMap : null,
        totalCount:
          values[1].data.v7PropertiesStats[0] &&
          values[1].data.v7PropertiesStats.length > 0 &&
          typeof  values[1].data.v7PropertiesStats[0].count === "string"
            ? Number( values[1].data.v7PropertiesStats[0].count)
            : limit,
        stats:  values[1].data.v7PropertiesStats[0],
        error: values[0].data.v7PropertiesMap.length > 0  ? null : values[0].data.v7PropertiesMap.message,
        isBusy: null,
        query,
      });
    });
  }

  componentDidUpdate(prevProps) {
    if (!shallowequal(prevProps.location.query, this.props.location.query)) {
      this.fetch(this.props.location.query);
    }
  }

  render() {
    return (
      <ApolloConsumer>
        {(client) => {
          if (!this.client) {
            this.client = client;
            // this.fetch(this.props.location.query);
          }
          return (
            <div className="ListingMap" data-is-busy={this.state.isBusy}>
              <ListStats stats={this.state.stats} query={this.state.query} />
              <ListMap listings={this.state.items} />
              <ListResults
                query={this.props.location.query}
                pathname={this.props.location.pathname}
                error={this.state.error}
                totalCount={this.state.totalCount}
                itemCount={this.state.items ? this.state.items.length : false}
                limit={limit}
              />
            </div>
          );
        }}
      </ApolloConsumer>
    );
  }
}
